import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmailIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Email",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.48 25h21.03c1.92 0 3.48-1.56 3.48-3.48V10.48c0-1.92-1.56-3.48-3.48-3.48H5.48C3.56 7 2 8.56 2 10.48v11.04C2 23.44 3.56 25 5.48 25m.87-12.28a1 1 0 0 1 .77-1.64c.19 0 .37.05.53.15s7.02 6.24 7.02 6.24c.35.32.82.51 1.33.51s.98-.19 1.33-.51 7.02-6.24 7.02-6.24c.18-.16.41-.25.67-.25a1 1 0 0 1 .66 1.75s-3.48 3.11-3.48 3.11l3.54 3.43c.2.18.33.45.33.74a.997.997 0 0 1-1.72.69l-3.64-3.54-2.06 1.79c-.7.63-1.64 1.01-2.66 1.01s-1.96-.38-2.67-1.01l-2.02-1.79-3.63 3.54a.997.997 0 1 1-1.39-1.43s3.54-3.43 3.54-3.43z"
    })
  }));
};